<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Supvervisor Help Requests
      </h2>
      <p class="tw-italic tw-text-gray-700">

      </p>
    </b-container>
    <hr>

<b-card no-body>
    <b-tabs card fill>
      <b-tab :title="'NEW REQUESTS ('+requests.length+')'" active>
        <b-card-text >
            <b-table striped hover :fields="fields" :items="requests" :current-page="currentPage"
            :per-page="perPage">

            <template v-slot:cell(attachment_link)="data">
                <!-- Only show approve/decline buttons for new requests -->
                <b-link v-if="data.item.attachment_link" :href="data.item.attachment_link" target="_blank">Open in CommCare <i class="fas fa-external-link-alt"></i></b-link>
            </template>

             <template v-slot:cell(resolved)="data">
                <!-- Only show approve/decline buttons for new requests -->
                <b-button @click="resolve(data.index)" size="sm" variant="success" class="w-20"><i class="fa fa-check"></i></b-button>
            </template>
            
            </b-table>
            <b-row v-if="totalRows > perPage">
            <b-col sm="12" md="12" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
                ></b-pagination>
            </b-col>
            </b-row>
        </b-card-text>
      </b-tab>

      <b-tab :title="'COMPLETED REQUESTS ('+completed.length+')'">
        <b-card-text >
            <b-table striped hover :fields="dismissed_fields" :items="completed" :current-page="currentPage"
            :per-page="perPage">

            <template v-slot:cell(attachment_link)="data">
                <!-- Only show approve/decline buttons for new requests -->
                <b-link v-if="data.item.attachment_link" :href="data.item.attachment_link" target="_blank">Open in CommCare <i class="fas fa-external-link-alt"></i></b-link>
            </template>
            
            </b-table>
            <b-row v-if="totalRows > perPage">
            <b-col sm="12" md="12" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
                ></b-pagination>
            </b-col>
            </b-row>
        </b-card-text>
      </b-tab>
    
    </b-tabs>
</b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import * as _ from "lodash";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "meta_username", label: "Username", sortable: true },
        { key: "contact_date", label: "Date", sortable: true },
        { key: "cluster_number", label: "Cluster" },
        { key: "remarks"},
        { key: "contact_number" },
        { key: "attachment_link" },
        { key: "resolved", label: "Mark as Resolved" }
      ],
      dismissed_fields: [
        { key: "meta_username", label: "Username", sortable: true },
        { key: "contact_date", label: "Date", sortable: true },
        { key: "cluster_number", label: "Cluster" },
        { key: "remarks"},
        { key: "contact_number" },
        { key: "attachment_link" }
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      requests: [],
      completed: []
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/supervisor-help-requests").then(response => {
      that.requests = [];
      _.each(response.data, function(item){
          if(item.resolved){
              that.completed.push(item);
          }
          else{
              that.requests.push(item);
          }
      });
      that.totalRows = response.data.length;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('adverseevents', 
            ['getAdverseEventsCount', 'setAdverseEventsCount']),

    refreshSideNavCount(){
      this.getAdverseEventsCount().then((response) => {
                this.setAdverseEventsCount(response.data);
            });
    },

    resolve: function(index){
      let that = this;
      HTTP.post("/kenya/dismiss_row/", {
        table_name: 'contact_supervisor_form',
        row_id: that.requests[index].id
      }).then(() => {
          that.completed.push(that.requests[index]);
          that.requests.splice(index, 1);
          that.refreshSideNavCount();
      });

    }
  }
};
</script>

<style>
</style>